import * as zod from 'zod';

export const comboboxSchema = zod.object({
  value: zod.string(),
  label: zod.string(),
});
